export default __webpack_public_path__ + "static/media/Roboto-ThinItalic.7cd42d8d.woff";